import ContactView from './ContactView';
import ContentMain from './ContentMain';
import ContentMainA from './ContentMainA';
import { useEffect, useState } from 'react';
import NewSlider from './Slider/NewSlider';
import HomeMessage from './HomeMessage/HomeMessage';
import './Home.css';
import ContentMainOld from './ContentMainOld';

export default function Home() {
  const [hasActiveMessage, setHasActiveMessage] = useState(true);

  useEffect(() => {
    document.title = 'Home - Jesuit Madurai Province Archives (JEMPARC)';
    window.scrollTo(0, 0);
    document.body.classList.add('home-page');
  }, []);

  return (
    <div>
      <div className="container-fluid home-top-split py-3 py-md-4">
        <div className="row g-3 g-lg-4 align-items-stretch">
          <div className={hasActiveMessage ? 'col-12 col-md-8' : 'col-12 col-md-12'}>
            <div className="home-top-slider h-100">
              <NewSlider />
            </div>
          </div>
          {hasActiveMessage && (
            <div className="col-12 col-md-4">
              <div className="home-top-message h-100">
                <HomeMessage compact onMessageAvailabilityChange={setHasActiveMessage} />
              </div>
            </div>
          )}
        </div>
      </div>
      <ContentMain />
      {/*ContentMainA is the new design*/}
      {/*<ContentMainA />*/}
      {/*} <OtherView /> */}
      <ContactView />
    </div>
  );
}
